import { countries } from 'countries-list';

// eslint-disable-next-line import/prefer-default-export
export const getCountryPrefix = (key) => {
  const country = countries[key];

  if (!country) {
    return '+';
  }

  return `+${country.phone}`;
};

export const getCountryCodes = () =>
  Object.entries(countries).flatMap(([code, { emoji, name, phone }]) =>
    phone.split(',').map((rawPhone) => {
      const dial = rawPhone.trim();

      return {
        label: `${emoji} ${name} (+${dial})`,
        short: `${emoji} +${dial}`,
        value: code,
      };
    }),
  );

export const parsePhoneNumber = (phoneNumber) => {
  const preferredCountries = ['NZ', 'AU', 'US', 'GB', 'CA'];

  if (!phoneNumber) {
    return null;
  }

  // Build dial code to ISO map with preferred countries prioritized
  const dialCodeToISO = Object.entries(countries).reduce((acc, [iso, data]) => {
    data.phone.split(',').forEach((code) => {
      const trimmedCode = code.trim();
      const existing = acc[trimmedCode];
      if (
        !existing ||
        (preferredCountries.includes(iso) &&
          !preferredCountries.includes(existing))
      ) {
        acc[trimmedCode] = iso;
      }
    });
    return acc;
  }, {});

  // Normalize input: remove spaces, dashes, parentheses; replace leading 00 with +
  const normalized = phoneNumber
    .trim()
    .replace(/[\s\-().]/g, '')
    .replace(/^00/, '+');

  if (!normalized.startsWith('+')) return null;

  // Sort dial codes descending by length to match longest prefix first
  const dialCodes = Object.keys(dialCodeToISO).sort(
    (a, b) => b.length - a.length,
  );

  const matchedCode = dialCodes.find((code) =>
    normalized.startsWith(`+${code}`),
  );

  if (!matchedCode) {
    return null;
  }

  const iso = dialCodeToISO[matchedCode];
  const localNumber = normalized.slice(matchedCode.length + 1);

  return { iso, localNumber };
};
